/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("dx.webapp.masterTools").
controller("DxMasterToolsStudentViewController", function MasterToolsStudentViewController(
	$scope,
	$routeParams,

	NodeRepository,
	Node,
	user,
	student,
	group,
	examState,
	DxUser,
	DxStudent,
	dxApi,

	dxLocalize
) {
	"use strict";

	$scope.student = new DxStudent();
	$scope.user = new DxUser();
	$scope.error = "";
	$scope.examToMove = null;
	$scope.toStudent = {};
	$scope.isSaving = false;
	$scope.saveExamMessage = "";

	var studentId = parseInt($routeParams.id, 10);

	$scope.saveStudent = function saveStudent() {
		student.update($scope.student).then(function success(response) {
			if (response.faults) {
				$scope.saveStudentMessage = response.msgs[0];
			} else {
				$scope.student = new DxStudent(response);
				$scope.saveStudentMessage = "Saved!";

				if ($scope.user.id !== $scope.student.userId) {
					$scope.refreshUser();
				}
			}
		});
	};

	$scope.refreshUser = function refreshUser() {
		if ($scope.student.userId) {
			user.get($scope.student.userId).then(function success(usr) {
				$scope.user = new DxUser(usr);
				$scope.error = "";
			}, function fail(err) {
				$scope.error = err.data.msgs.join(".");
			});
		} else {
			$scope.user = new DxUser();
		}
	};

	$scope.isMoveExamValid = function isMoveExamValid() {
		return $scope.examToEdit !== null && $scope.toStudent.id !== null && !$scope.isSaving;
	};

	$scope.moveExam = function moveExam() {
		if (!$scope.isMoveExamValid()) {
			return;
		}

		$scope.isSaving = true;

		dxApi.legacy.masterTools.moveExam($scope.examToEdit.id, $scope.student.id, $scope.toStudent.id).
			then(function success() {
				$scope.saveExamMessage = "Exam has been moved";
				$scope.isSaving = false;

				student.exams(studentId).then(function moveSuccess(response) {
					$scope.exams = response;
				});
			}, function fail(response) {
				$scope.saveExamMessage = response.data.msgs[0];
				$scope.isSaving = false;
			});
	};

	$scope.cancelSettings = function cancelSettings() {
		$scope.examToEdit = null;
		$scope.saveExamMessage = "";
	};

	function changeExamState() {
		if (!$scope.examStateChanged()) {
			return;
		}

		$scope.isSaving = true;

		dxApi.legacy.masterTools.changeExamState($scope.examToEdit.id,	studentId, $scope.examToEdit.settings.state).
			then(function success() {
				$scope.saveExamMessage = "Exam has changed state";
				$scope.examToEditCurrentState = $scope.examToEdit.settings.state;
				$scope.isSaving = false;
			}, function fail(response) {
				$scope.saveExamMessage = response.data.msgs[0];
				$scope.isSaving = false;
			});
	}

	$scope.stateOptions = [
		{value: examState.BLANK, name: dxLocalize.get("Exam.State." + examState.BLANK)},
		{value: examState.EMPTY, name: dxLocalize.get("Exam.State." + examState.EMPTY)},
		{value: examState.DRAFT, name: dxLocalize.get("Exam.State." + examState.DRAFT)},
		{value: examState.FINAL, name: dxLocalize.get("Exam.State." + examState.FINAL)},
	];

	$scope.saveExam = function saveExam() {
		if ($scope.examStateChanged()) {
			changeExamState();
		}

		if ($scope.isMoveExamValid()) {
			$scope.moveExam();
		}
	};

	$scope.examStateChanged = function examStateChanged() {
		return $scope.examToEdit.settings.state !== $scope.examToEditCurrentState && !$scope.isSaving;
	};

	$scope.openExamSettings = function openExamSettings(e) {
		$scope.examToEdit = e;
		$scope.examToEditCurrentState = e.settings.state;
		$scope.toStudent.id = null;
	};

	$scope.isExamSaveButtonDisabled = function isExamSaveButtonDisabled() {
		return (!$scope.isMoveExamValid() && !$scope.examStateChanged()) || ($scope.isMoveExamValid() && $scope.examStateChanged());
	};

	student.get(studentId).then(function success(stdnt) {
		$scope.student = new DxStudent(stdnt);

		if ($scope.student.redactedPii) {
			$scope.student.code = "";
			$scope.student.firstName = dxLocalize.get("RedactedPii.StudentName");
			$scope.student.lastName = "";
		}

		$scope.refreshUser();

		NodeRepository.load($scope.student.organizationId).then(function loadStudentOG(organization) {
			$scope.organization = new Node(organization);
		});

		return group.query({studentId: studentId}).then(function groups(response) {
			$scope.groups = response.data;
		});
	});

	student.exams(studentId).then(function success(response) {
		$scope.exams = response;
	});
});
